function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $7c40e7e4b52f25f8$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"1LzKV":"index.f59033f2.js","aPLAx":"antetopounmpo_full.353e56e1.webp","eR9Gx":"antetopounmpo_cutout.1dabb064.webp","iOzyL":"antetopounmpo_slab.fcf52575.webp","kXAa2":"doncic_full.cb156da8.webp","a0IER":"doncic_cutout.29e0e61c.webp","a1xev":"doncic_slab.9decbfaa.webp","2ZP5k":"jokic_full.e834c8df.webp","f2EKX":"jokic_cutout.30ed77fd.webp","4ghnE":"jokic_slab.cc9c6b93.webp","8Ovpe":"lebron_full.94dd7320.webp","g13tt":"lebron_cutout.ca669fc4.webp","VlSMT":"lebron_slab.d3ae282f.webp","byBKb":"stephen_full.ade243f5.webp","zvbWj":"stephen_cutout.0ff887a6.webp","l1LF7":"stephen_slab.27a45e46.webp","bWj3p":"denver_nuggets.914b072f.png","fox0m":"mavericks_logo.07af3af7.png","d62Tf":"la_lakers.8dec7951.png","9trQc":"milwaukee_bucks.cb726464.png","9RNmp":"golden_state_warriors.4b5ac6c1.png","7sqJA":"chart_blue.f7411cab.png"}'));

var $dba660e15e35f500$exports = {};

$dba660e15e35f500$exports = new URL((parcelRequire("27Lyk")).resolve("aPLAx"), import.meta.url).toString();


var $85d5d6582622bf8f$exports = {};

$85d5d6582622bf8f$exports = new URL((parcelRequire("27Lyk")).resolve("eR9Gx"), import.meta.url).toString();


var $84818a8a8302f1f8$exports = {};

$84818a8a8302f1f8$exports = new URL((parcelRequire("27Lyk")).resolve("iOzyL"), import.meta.url).toString();


var $7ef7ff20fd189f7d$exports = {};

$7ef7ff20fd189f7d$exports = new URL((parcelRequire("27Lyk")).resolve("kXAa2"), import.meta.url).toString();


var $f160d758f18b16ce$exports = {};

$f160d758f18b16ce$exports = new URL((parcelRequire("27Lyk")).resolve("a0IER"), import.meta.url).toString();


var $2a5ec110f1995d5b$exports = {};

$2a5ec110f1995d5b$exports = new URL((parcelRequire("27Lyk")).resolve("a1xev"), import.meta.url).toString();


var $2dfcaab7ed866f19$exports = {};

$2dfcaab7ed866f19$exports = new URL((parcelRequire("27Lyk")).resolve("2ZP5k"), import.meta.url).toString();


var $68ca64197838e75d$exports = {};

$68ca64197838e75d$exports = new URL((parcelRequire("27Lyk")).resolve("f2EKX"), import.meta.url).toString();


var $03d2f37b05782762$exports = {};

$03d2f37b05782762$exports = new URL((parcelRequire("27Lyk")).resolve("4ghnE"), import.meta.url).toString();


var $f9d848835dee2e1d$exports = {};

$f9d848835dee2e1d$exports = new URL((parcelRequire("27Lyk")).resolve("8Ovpe"), import.meta.url).toString();


var $ca0c7e067ce361a6$exports = {};

$ca0c7e067ce361a6$exports = new URL((parcelRequire("27Lyk")).resolve("g13tt"), import.meta.url).toString();


var $603ecfa6e9ca8bcb$exports = {};

$603ecfa6e9ca8bcb$exports = new URL((parcelRequire("27Lyk")).resolve("VlSMT"), import.meta.url).toString();


var $26b9bec0b4ca280b$exports = {};

$26b9bec0b4ca280b$exports = new URL((parcelRequire("27Lyk")).resolve("byBKb"), import.meta.url).toString();


var $e6fcfc7560413c4e$exports = {};

$e6fcfc7560413c4e$exports = new URL((parcelRequire("27Lyk")).resolve("zvbWj"), import.meta.url).toString();


var $cc6702b5e8808d7e$exports = {};

$cc6702b5e8808d7e$exports = new URL((parcelRequire("27Lyk")).resolve("l1LF7"), import.meta.url).toString();


var $7f2af41d3562db61$exports = {};

$7f2af41d3562db61$exports = new URL((parcelRequire("27Lyk")).resolve("bWj3p"), import.meta.url).toString();


var $f0b79c382a239c74$exports = {};

$f0b79c382a239c74$exports = new URL((parcelRequire("27Lyk")).resolve("fox0m"), import.meta.url).toString();


var $bb9cbe9782cd66e6$exports = {};

$bb9cbe9782cd66e6$exports = new URL((parcelRequire("27Lyk")).resolve("d62Tf"), import.meta.url).toString();


var $f1b30f4c96ca6833$exports = {};

$f1b30f4c96ca6833$exports = new URL((parcelRequire("27Lyk")).resolve("9trQc"), import.meta.url).toString();


var $749ee713c7f49029$exports = {};

$749ee713c7f49029$exports = new URL((parcelRequire("27Lyk")).resolve("9RNmp"), import.meta.url).toString();


var $9c37e7e62f4e5fec$exports = {};

$9c37e7e62f4e5fec$exports = new URL((parcelRequire("27Lyk")).resolve("7sqJA"), import.meta.url).toString();


const $9a8cebc34540b0c1$export$4051a07651545597 = [
    {
        id: "panini-certified-luka-doncic-mirror-blue",
        info: {
            value: "1.7 ETH",
            chartImageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($9c37e7e62f4e5fec$exports))),
            title: "Panini Certified Luka Donic Mirror Blue",
            cardTraits: [
                {
                    title: "Price",
                    value: "190"
                },
                {
                    title: "Brand",
                    value: "Panini"
                },
                {
                    title: "Varient",
                    value: "Certified"
                },
                {
                    title: "Tier",
                    value: "Mirror Blue"
                },
                {
                    title: "Grade",
                    value: "Mint 9"
                },
                {
                    title: "Card Num",
                    value: "153"
                },
                {
                    title: "Pop",
                    value: "36"
                },
                {
                    title: "Serial Num",
                    value: "70608092"
                },
                {
                    title: "Year",
                    value: "2018"
                }
            ]
        },
        player: {
            name: "Luka Donic",
            team: "Dallas Mavericks",
            subtitle1: "missing",
            subtitle2: "missing",
            teamLogoUrl: (0, (/*@__PURE__*/$parcel$interopDefault($f0b79c382a239c74$exports))),
            statTitle: "missing",
            stats: [
                {
                    title: "Games Played",
                    value: "72"
                },
                {
                    title: "PPG",
                    value: "21.2"
                },
                {
                    title: "FG%",
                    value: "42.7"
                },
                {
                    title: "AST",
                    value: "6"
                },
                {
                    title: "REB",
                    value: "7.8"
                },
                {
                    title: "BLK",
                    value: "0.3"
                },
                {
                    title: "STL",
                    value: "1.1"
                },
                {
                    title: "3PT%",
                    value: "32.7"
                },
                {
                    title: "Height",
                    value: "6' 7"
                },
                {
                    title: "Weight",
                    value: "230"
                },
                {
                    title: "DOB",
                    value: "2/28/1999"
                },
                {
                    title: "Draft Num",
                    value: "3"
                },
                {
                    title: "APG",
                    value: "6.0"
                },
                {
                    title: "RPG",
                    value: "7.8"
                },
                {
                    title: "BPG",
                    value: "0.3"
                },
                {
                    title: "SPG",
                    value: "1.1"
                },
                {
                    title: "3P%",
                    value: "0.327"
                },
                {
                    title: "MPG",
                    value: "32.2"
                }
            ]
        },
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($7ef7ff20fd189f7d$exports))),
        cutoutUrl: (0, (/*@__PURE__*/$parcel$interopDefault($f160d758f18b16ce$exports))),
        slabUrl: (0, (/*@__PURE__*/$parcel$interopDefault($2a5ec110f1995d5b$exports)))
    },
    {
        id: "panini-select-nikola-jokic-silver-prizm",
        info: {
            value: "1.1 ETH",
            chartImageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($9c37e7e62f4e5fec$exports))),
            title: "Panini Select Nikola Jokic Silver Prizm",
            cardTraits: [
                {
                    title: "Price",
                    value: "455"
                },
                {
                    title: "Brand",
                    value: "Panini"
                },
                {
                    title: "Varient",
                    value: "Select"
                },
                {
                    title: "Tier",
                    value: "Silver Prizm"
                },
                {
                    title: "Grade",
                    value: "Gem MT 10"
                },
                {
                    title: "Card Num",
                    value: "30"
                },
                {
                    title: "Pop",
                    value: "10"
                },
                {
                    title: "Serial Num",
                    value: "75618833"
                },
                {
                    title: "Year",
                    value: "2017"
                }
            ]
        },
        player: {
            name: "Nikola Jokic",
            team: "Denver Nuggets",
            subtitle1: "missing",
            subtitle2: "missing",
            teamLogoUrl: (0, (/*@__PURE__*/$parcel$interopDefault($7f2af41d3562db61$exports))),
            statTitle: "missing",
            stats: [
                {
                    title: "Games Played",
                    value: "75"
                },
                {
                    title: "PPG",
                    value: "18.5"
                },
                {
                    title: "FG%",
                    value: "49.9"
                },
                {
                    title: "AST",
                    value: "6.1"
                },
                {
                    title: "REB",
                    value: "10.7"
                },
                {
                    title: "BLK",
                    value: "0.8"
                },
                {
                    title: "STL",
                    value: "1.2"
                },
                {
                    title: "3PT%",
                    value: "39.6"
                },
                {
                    title: "Height",
                    value: "6' 11"
                },
                {
                    title: "Weight",
                    value: "284"
                },
                {
                    title: "DOB",
                    value: "2/19/1995"
                },
                {
                    title: "Draft Num",
                    value: "41"
                }
            ]
        },
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($2dfcaab7ed866f19$exports))),
        cutoutUrl: (0, (/*@__PURE__*/$parcel$interopDefault($68ca64197838e75d$exports))),
        slabUrl: (0, (/*@__PURE__*/$parcel$interopDefault($03d2f37b05782762$exports)))
    },
    {
        id: "panini-select-joel-embiid-silver-prizm",
        info: {
            value: "5.1 ETH",
            chartImageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($9c37e7e62f4e5fec$exports))),
            title: "Prizm Monopoly LeBron James",
            cardTraits: [
                {
                    title: "Price",
                    value: "182"
                },
                {
                    title: "Brand",
                    value: "Panini"
                },
                {
                    title: "Varient",
                    value: "Monopoly"
                },
                {
                    title: "Tier",
                    value: "Silver Prizm"
                },
                {
                    title: "Grade",
                    value: "Gem MT 10"
                },
                {
                    title: "Card Num",
                    value: "40"
                },
                {
                    title: "Pop",
                    value: "4"
                },
                {
                    title: "Serial Num",
                    value: "74839939"
                },
                {
                    title: "Year",
                    value: "2022"
                }
            ]
        },
        player: {
            name: "LeBron James",
            team: "LA Lakers",
            subtitle1: "missing",
            subtitle2: "missing",
            teamLogoUrl: (0, (/*@__PURE__*/$parcel$interopDefault($bb9cbe9782cd66e6$exports))),
            statTitle: "missing",
            stats: [
                {
                    title: "Games Played",
                    value: "55"
                },
                {
                    title: "PPG",
                    value: "28.9"
                },
                {
                    title: "FG%",
                    value: "50"
                },
                {
                    title: "AST",
                    value: "6.8"
                },
                {
                    title: "REB",
                    value: "8.3"
                },
                {
                    title: "BLK",
                    value: "0.6"
                },
                {
                    title: "STL",
                    value: "0.9"
                },
                {
                    title: "3PT%",
                    value: "32.1"
                },
                {
                    title: "Height",
                    value: "6' 9"
                },
                {
                    title: "Weight",
                    value: "250"
                },
                {
                    title: "DOB",
                    value: "12/30/1984"
                },
                {
                    title: "Draft Num",
                    value: "1"
                }
            ]
        },
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($f9d848835dee2e1d$exports))),
        cutoutUrl: (0, (/*@__PURE__*/$parcel$interopDefault($ca0c7e067ce361a6$exports))),
        slabUrl: (0, (/*@__PURE__*/$parcel$interopDefault($603ecfa6e9ca8bcb$exports)))
    },
    {
        id: "panini-instant-stephen-curry",
        info: {
            value: "0.3 ETH",
            chartImageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($9c37e7e62f4e5fec$exports))),
            title: "Panini Instant Stephen Curry",
            cardTraits: [
                {
                    title: "Price",
                    value: "300"
                },
                {
                    title: "Brand",
                    value: "Panini"
                },
                {
                    title: "Varient",
                    value: "Instant"
                },
                {
                    title: "Tier",
                    value: "Versicolor"
                },
                {
                    title: "Grade",
                    value: "Mint 9"
                },
                {
                    title: "Card Num",
                    value: "29"
                },
                {
                    title: "Pop",
                    value: "1"
                },
                {
                    title: "Serial Num",
                    value: "69511270"
                },
                {
                    title: "Year",
                    value: "2022"
                }
            ]
        },
        player: {
            name: "Stephen Curry",
            team: "Golden State Warriors",
            subtitle1: "missing",
            subtitle2: "missing",
            teamLogoUrl: (0, (/*@__PURE__*/$parcel$interopDefault($749ee713c7f49029$exports))),
            statTitle: "missing",
            stats: [
                {
                    title: "Games Played",
                    value: "56"
                },
                {
                    title: "PPG",
                    value: "29.4"
                },
                {
                    title: "FG%",
                    value: "49.3"
                },
                {
                    title: "AST",
                    value: "6.3"
                },
                {
                    title: "REB",
                    value: "6.1"
                },
                {
                    title: "BLK",
                    value: "0.4"
                },
                {
                    title: "STL",
                    value: "0.9"
                },
                {
                    title: "3PT%",
                    value: "42.7"
                },
                {
                    title: "Height",
                    value: "6' 2"
                },
                {
                    title: "Weight",
                    value: "185"
                },
                {
                    title: "DOB",
                    value: "3/14/1988"
                },
                {
                    title: "Draft Num",
                    value: "7"
                }
            ]
        },
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($26b9bec0b4ca280b$exports))),
        cutoutUrl: (0, (/*@__PURE__*/$parcel$interopDefault($e6fcfc7560413c4e$exports))),
        slabUrl: (0, (/*@__PURE__*/$parcel$interopDefault($cc6702b5e8808d7e$exports)))
    },
    {
        id: "panini-select-joel-embiid-silver-prizm",
        info: {
            value: "0.125 ETH",
            chartImageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($9c37e7e62f4e5fec$exports))),
            title: "Giannis Franchise Fav-Gold",
            cardTraits: [
                {
                    title: "Price",
                    value: "3400"
                },
                {
                    title: "Brand",
                    value: "Panini"
                },
                {
                    title: "Varient",
                    value: "Illusions"
                },
                {
                    title: "Tier",
                    value: "Gold Franchise Favorites"
                },
                {
                    title: "Grade",
                    value: "Gem MT 10"
                },
                {
                    title: "Card Num",
                    value: "13"
                },
                {
                    title: "Pop",
                    value: "3"
                },
                {
                    title: "Serial Num",
                    value: "73710308"
                },
                {
                    title: "Year",
                    value: "2021"
                }
            ]
        },
        player: {
            name: "Giannis Antetokounmpo",
            team: "Milkwaukee Bucks",
            subtitle1: "Milkwaukee Bucks",
            subtitle2: "missing",
            teamLogoUrl: (0, (/*@__PURE__*/$parcel$interopDefault($f1b30f4c96ca6833$exports))),
            statTitle: "missing",
            stats: [
                {
                    title: "Games Played",
                    value: "67"
                },
                {
                    title: "PPG",
                    value: "29.9"
                },
                {
                    title: "FG%",
                    value: "55.3"
                },
                {
                    title: "AST",
                    value: "5.8"
                },
                {
                    title: "REB",
                    value: "11.6"
                },
                {
                    title: "BLK",
                    value: "1.4"
                },
                {
                    title: "STL",
                    value: "1.1"
                },
                {
                    title: "3PT%",
                    value: "29.3"
                },
                {
                    title: "Height",
                    value: "6' 11"
                },
                {
                    title: "Weight",
                    value: "243"
                },
                {
                    title: "DOB",
                    value: "12/6/1994"
                },
                {
                    title: "Draft Num",
                    value: "15"
                }
            ]
        },
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($dba660e15e35f500$exports))),
        cutoutUrl: (0, (/*@__PURE__*/$parcel$interopDefault($85d5d6582622bf8f$exports))),
        slabUrl: (0, (/*@__PURE__*/$parcel$interopDefault($84818a8a8302f1f8$exports)))
    }
];


const $b4e14b6b8da86996$var$container = document.querySelector(".container");
let $b4e14b6b8da86996$var$imageCanvasPromises = {};
async function $b4e14b6b8da86996$var$getPixelColor(xPercent, yPercent, imagePath) {
    if (!$b4e14b6b8da86996$var$imageCanvasPromises[imagePath]) {
        console.log(`Loading image ${imagePath} for the first time`);
        const loadImageAndCreateCanvas = new Promise((resolve, reject)=>{
            const image = new Image();
            image.onload = ()=>{
                const canvas = document.createElement("canvas");
                canvas.width = image.width;
                canvas.height = image.height;
                const context = canvas.getContext("2d");
                context.drawImage(image, 0, 0, image.width, image.height);
                resolve(canvas);
            };
            image.onerror = (e)=>reject(e);
            image.src = imagePath;
        });
        // Immediately store the loading process (Promise) in the cache
        $b4e14b6b8da86996$var$imageCanvasPromises[imagePath] = loadImageAndCreateCanvas;
    }
    // Now, 'imageCanvasPromises[imagePath]' is always a Promise here
    const canvas = await $b4e14b6b8da86996$var$imageCanvasPromises[imagePath];
    const context = canvas.getContext("2d");
    // Calculate the x, y based of percentage of width and height
    const xPos = Math.floor(xPercent * canvas.width / 100);
    const yPos = Math.floor(yPercent * canvas.height / 100);
    const pixelData = context.getImageData(xPos, yPos, 1, 1).data;
    return pixelData;
}
// Add these at the beginning of ./src/index.ts
const $b4e14b6b8da86996$var$sampleInfoText = [
    {
        position: "left",
        text: "Random Stat 1: 42"
    },
    {
        position: "right",
        text: "Random Stat 2: 7"
    },
    {
        position: "top",
        text: "Random Stat 3: 99"
    },
    {
        position: "bottom",
        text: "Random Stat 4: 256"
    }
];
const $b4e14b6b8da86996$var$navbar = document.querySelector(".navbar");
const $b4e14b6b8da86996$var$exitInspectMode = (card)=>{
    $b4e14b6b8da86996$var$navbar.style.setProperty("visibility", "visible");
    card.classList.remove("focused");
    //add display:none to .inspect
    const inspect = document.querySelector(".inspect");
    inspect.classList.add("hidden");
    inspect.classList.remove("inspect-mode");
    $b4e14b6b8da86996$var$container.classList.remove("inspect-mode");
    card.style.removeProperty("--center-x");
    card.style.removeProperty("--center-y");
    const otherCards = Array.from($b4e14b6b8da86996$var$container.querySelectorAll("tilt-card")).filter((c)=>c !== card);
    otherCards.forEach((c, index)=>{
        setTimeout(()=>{
            c.classList.remove("fade-out");
            c.classList.add("fade-in");
        }, index * 0);
    });
    card.setAttribute("data-maxheight", $b4e14b6b8da86996$var$CARD_HEIGHT_GRID);
    Array.from(card.shadowRoot.querySelectorAll(".info-text")).forEach((textEl)=>textEl.remove());
};
async function $b4e14b6b8da86996$var$mouseIntersectsWithNonTransparentPixel(xPercentage, yPercentage, imageUrl) {
    const pixelColor = await $b4e14b6b8da86996$var$getPixelColor(xPercentage, yPercentage, imageUrl);
    if (pixelColor[3] === 0) return true;
    return false;
}
const $b4e14b6b8da86996$var$CARD_HEIGHT_GRID = "260";
function $b4e14b6b8da86996$var$createHTMLElement(htmlString) {
    const template = document.createElement("template");
    template.innerHTML = htmlString.trim();
    return template.content.firstChild;
}
for(let i = 0; i < (0, $9a8cebc34540b0c1$export$4051a07651545597).length; i++){
    const cardContainer = document.createElement("div");
    cardContainer.classList.add("grid-card-container");
    const cardContainerInner = document.createElement("div");
    cardContainerInner.classList.add("grid-card-container-inner");
    const shareIcon = document.createElement("div");
    shareIcon.classList.add("grid-card-share-icon");
    cardContainerInner.appendChild(shareIcon);
    const cardInfo = $b4e14b6b8da86996$var$createHTMLElement(`
	<div>
		<div class="grid-card-title">
			Panini Select Nikola Jokic Silver Prizm
		</div>
		<div class="grid-card-price">
			1.2 ETH
		</div>
		<div class="grid-card-button-container">
			<div class="grid-card-button-sell">
			<div class="grid-card-sell-icon"></div>
			Sell</div>
			<div class="grid-card-button-redeem">Redeem</div>
		</div>
	</div> `);
    const title = cardInfo.querySelector(".grid-card-title");
    const price = cardInfo.querySelector(".grid-card-price");
    title.innerText = (0, $9a8cebc34540b0c1$export$4051a07651545597)[i].info.title;
    price.innerText = (0.5 + Math.random() * 1.3).toFixed(2) + " ETH";
    const card = document.createElement("tilt-card");
    const info = (0, $9a8cebc34540b0c1$export$4051a07651545597)[i];
    console.log(info);
    if (info) {
        card.setAttribute("data-cardurl", info.imageUrl);
        card.setAttribute("data-cutouturl", info.cutoutUrl);
        card.setAttribute("data-slaburl", info.slabUrl);
        card.setAttribute("data-raw", JSON.stringify(info));
        card.setAttribute("data-maxheight", $b4e14b6b8da86996$var$CARD_HEIGHT_GRID);
    } else throw "info is undefined";
    const rightSide = document.querySelector(".right-column");
    const leftSide = document.querySelector(".left-column");
    const playerNameDiv = document.querySelector(".player-name");
    const teamSubtitleDiv = document.querySelector(".team-subtitle");
    const teamTitleDiv = document.querySelector(".team-title");
    const teamImage = document.querySelector(".team-logo");
    const leftSideTable = document.querySelector(".left-side-table");
    const rightSideTable = document.querySelector(".right-side-table");
    card.addEventListener("click", function() {
        const inspectScreen = document.querySelector("inspect-screen");
        if (inspectScreen) inspectScreen.remove();
        else {
            console.log("clicked");
            const inspectScreen = document.createElement("inspect-screen");
            inspectScreen.setAttribute("data-card-info", JSON.stringify(info));
            $b4e14b6b8da86996$var$container?.appendChild(inspectScreen);
        }
    });
    i;
    const playerCutout = card.shadowRoot.querySelector(".player-cutout");
    const slabCutout = card.shadowRoot.querySelector(".slab-cutout");
    //on hover over player cutout, move the card to the left and hide the team info
    playerCutout.addEventListener("mousemove", async function(event) {
        //hide the team info, which is in .right-side. animate over 1 second
        //get the pixel on player-cutout that is hovered over
        const rect = playerCutout.getBoundingClientRect();
        const x = event.clientX - rect.left; //x position within the element.
        const y = event.clientY - rect.top; //y position within the element.
        const xPercentage = x / rect.width * 100;
        const yPercentage = y / rect.height * 100;
        const intersectsWithPlayer = await $b4e14b6b8da86996$var$mouseIntersectsWithNonTransparentPixel(xPercentage, yPercentage, info.cutoutUrl);
        const intersectsWithSlab = await $b4e14b6b8da86996$var$mouseIntersectsWithNonTransparentPixel(xPercentage, yPercentage, info.slabUrl);
        try {
            intersectsWithPlayer;
            intersectsWithSlab;
        } catch (e) {
            console.log("error", e);
        }
    });
    //on mouse leave, move the card back to the center and show the team info
    playerCutout.addEventListener("mouseleave", function() {
        //show the team info, which is in .right-side. animate over 1 second
        const rightSide = document.querySelector(".left-column");
        //delete opacity property
        if (rightSide) rightSide.style.removeProperty("opacity");
    });
    //set max height for card to 260px
    cardContainerInner.appendChild(card);
    cardContainer.appendChild(cardContainerInner);
    cardContainer.appendChild(cardInfo);
    $b4e14b6b8da86996$var$container.appendChild(cardContainer);
}
document.body.addEventListener("click", function(e) {
    let card = Array.from($b4e14b6b8da86996$var$container.querySelectorAll("tilt-card")).find((card)=>card.classList.contains("focused"));
    if (card && e.target !== card && !card.contains(e.target)) $b4e14b6b8da86996$var$exitInspectMode(card);
});


//# sourceMappingURL=index.f59033f2.js.map
